import { FileType } from '@fi-shared/types';

export function fiGetMediaBankFileIcon(fileType: FileType) {
    return fiGetMediaBankFileIconAwesome(fileType);
    /*switch (fileType) {
        case FileType.Image:
            return 'file-imageCcmIcon';
        case FileType.Pdf:
        case FileType.PdfNoPreview:
            return 'file-pdfCcmIcon';
        case FileType.Audio:
            return 'file-audioCcmIcon';
        case FileType.MsWord:
            return 'file-wordCcmIcon';
        case FileType.Document:
            return 'icon-doc-text-invCcmIcon';
        case FileType.Excel:
            return 'file-excelCcmIcon';
        case FileType.PowerPoint:
            return 'file-powerpointCcmIcon';
        case FileType.Movie:
        case FileType.MovieNotPlayable:
            return 'file-videoCcmIcon';
        case FileType.Compressed:
            return 'file-archiveCcmIcon';
        case FileType.StyleSheet:
        case FileType.JavaScript:
            return 'file-codeCcmIcon';
        case FileType.ImageWithoutPreview:
            return 'pictureCcmIcon';

        default:
            return 'icon-objectCcmIcon';
    }*/
}

export function fiGetMediaBankFileIconAwesome(fileType: FileType) {
    switch (fileType) {
        case FileType.Image:
            return 'fa-file-image';
        case FileType.Pdf:
        case FileType.PdfNoPreview:
            return 'fa-file-pdf';
        case FileType.Audio:
            return 'fa-file-audio';
        case FileType.MsWord:
            return 'fa-file-doc';
        case FileType.Document:
            return 'fa-file-alt';
        case FileType.Excel:
            return 'fa-file-xls';
        case FileType.PowerPoint:
            return 'fa-file-ppt';
        case FileType.Movie:
        case FileType.MovieNotPlayable:
            return 'fa-file-video';
        case FileType.Compressed:
            return 'fa-file-archive';
        case FileType.StyleSheet:
        case FileType.JavaScript:
            return 'fa-file-code';
        case FileType.ImageWithoutPreview:
            return 'fa-image';

        default:
            return 'fa-file-alt';
    }
}
